const filter = () => {
    return (durationInYears) => {
        let convertedDuration = "";
        let durationType = "";
        if (durationInYears < 0.082) {
            convertedDuration = Math.round(durationInYears * 365);
            durationType = convertedDuration == 1 ? "day" : "days";
        }
        else if (durationInYears < 1) {
            convertedDuration = Math.round(durationInYears * 12);
            durationType = convertedDuration == 1 ? "month" : "months";
        }
        else {
            convertedDuration = Math.round(durationInYears * 10) / 10;
            durationType = convertedDuration == 1 ? "year" : "years";
        }
        convertedDuration = convertedDuration + " " + durationType;
        return convertedDuration;
    };
};
const ɵ0 = filter;
export const ConvertDurationInYearsFilter = {
    name: 'convertDurationInYears',
    filter: filter
};
export { ɵ0 };
//# sourceMappingURL=fourdotfive-convert-duration-in-years.filter.js.map